export default "__VITE_ASSET__DExK3Tpr__"